import React, { useEffect, useState } from 'react';
import { Empty, List, Pagination, message } from 'antd';
import { getProjectActivity } from '@gtintel/platform-api';
import { LoadingSpinner2 } from '@gtintel/platform-atoms';
import Activity from './Activity';
const EmptyText = <Empty description="Nothing here yet" image={Empty.PRESENTED_IMAGE_SIMPLE} />;
const PAGE_SIZE = 10;
const ProjectActivityFeed = ({
  project
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [activityPage, setActivityPage] = useState(null);
  const loadPage = async pageNumber => {
    setIsLoading(true);
    try {
      const page = await getProjectActivity(project.id, {
        limit: PAGE_SIZE,
        offset: PAGE_SIZE * (pageNumber - 1)
      });
      setActivityPage(page);
    } catch (e) {
      message.error('Could not load activities');
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    loadPage(1);
  }, []);
  return <>
      {isLoading ? <LoadingSpinner2 margin="150px" /> : <List className="activity" dataSource={activityPage.results} style={{
      width: '100%'
    }} locale={{
      emptyText: EmptyText
    }} renderItem={activity => <List.Item>
              <Activity activity={activity} />
            </List.Item>} />}

      {activityPage && <Pagination defaultCurrent={1} defaultPageSize={PAGE_SIZE} hideOnSinglePage onChange={loadPage} pageSize={10} total={activityPage.count} />}
    </>;
};
export default ProjectActivityFeed;